import { connect } from 'react-redux'

import _ from 'lodash'
//import moment from 'moment'

import React from 'react';

import { Card, List, Modal, Button, Header, Segment, Dimmer, Loader } from 'semantic-ui-react'

import { 
    fetchDetailData
} from '../Actions/DashboardActions'


const sourceListSectionFields = [
  {
    field: "SOURCE",
    title: 'Source',
    format: (item) => { return item }
  },
  {
    field: "AFFILIATE_LOCATION",
    title: 'Affiliate Location',
    format: (item) => { return item }
  },
  {
    field: "AFFILIATE_XREF_NUMBER",
    title: 'Affiliate Cross Reference Number',
    format: (item) => { return item }
  },
  {
    field: "IDENTIFICATION_NUMBER",
    title: 'Source Reference Number',
    format: (item) => { return item }
  }
]


class SourceDetailView extends React.Component {

  state={ modalOpen: false }
  
    handleOpen = () => {
      this.props.fetchDetailData()
      this.setState({ modalOpen: true })
    }
  
    handleClose = () => {
      this.setState({ modalOpen: false })
    }
    
  
    
  
    render() {
      const noSourcesView = (
        <div>No Sources For This Case</div>
      )
  
      const sourceCards = (
        <Card.Group>
          {
            _.map(this.props.source_detail, (source, idx) => {
  
              let sourceListSection
              const sourceListSectionIsDefined = _.some(sourceListSectionFields, (section) => {
                return !_.isUndefined(source[section.field]) && source[section.field] !== null
              })
              if(sourceListSectionIsDefined) {
                sourceListSection = (
                  <Card.Content>
                    <List>
                      {
                        _.reduce(sourceListSectionFields, (result, section, idx) => {
                          if(!_.isUndefined(source[section.field]) && source[section.field] !== null) {
                            result.push(
                              <List.Item key={idx}>
                                <List.Header>{section.title}</List.Header>
                                {section.format(source[section.field])}
                              </List.Item>
                            )
                          }
                          return result
                        }, [])
                      }
                    </List>
                  </Card.Content>
                )
              }
  
              return (
                <Card fluid key={idx}>
                  {sourceListSection}
                </Card>
              )
            })
          }
        </Card.Group>
      )
  
  
      return (
          <Modal 
            trigger={<Button circular onClick={this.handleOpen} icon='hospital outline' color='teal' basic/>}
            open={this.state.modalOpen}
            onClose={this.handleClose}
            size='small'
          >
            <Header content='Sources' />
            <Modal.Content scrolling>
              {
                this.props.fetching_source_detail && 
                (
                  <Segment style={{height: '50vh'}}>
                    <Dimmer active>
                      <Loader>Loading</Loader>
                    </Dimmer>
                  </Segment>
                )
              }
              {!this.props.fetching_source_detail && (this.props.source_detail.length > 0 ? sourceCards : noSourcesView)}
            </Modal.Content>
          </Modal>
      )
    }
}


//Binds the current Redux state to props that the sub component (DashboardView) uses
const mapStateToProps = (state, ownProps) => {
  return {
    source_detail: _.get(state, 'dashboard.source_detail') || [],
    fetching_source_detail: _.get(state, 'dashboard.fetching_source_detail') || false
  }
}

//map actions to properties to allow subcomponents tp update state
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchDetailData: () => {
        dispatch(fetchDetailData(ownProps.record_id, 'source_detail'))
    }
  }
}

//Boilerplate code to connect the subcomponent to the Redux state - automatically determines if the subcomponent should update when the state is updated
export const SourceDetail = connect(
  mapStateToProps,
  mapDispatchToProps
)(SourceDetailView)

export default SourceDetail



// WEBPACK FOOTER //
// ./src/Components/SourceDetail.jsx